import { render, staticRenderFns } from "./totalCupons.vue?vue&type=template&id=3836b871&scoped=true"
import script from "./totalCupons.vue?vue&type=script&lang=js"
export * from "./totalCupons.vue?vue&type=script&lang=js"
import style0 from "./totalCupons.vue?vue&type=style&index=0&id=3836b871&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3836b871",
  null
  
)

export default component.exports